import React, { useState } from 'react'
import footerStyles from './footer.module.css'

import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import axios from "axios"
const Footer = () => {
  const[email,setEmail]=useState("")
  const[phone,setPhone]=useState("")
  const footersubmitHandler=(e)=>{
    e.preventDefault()
    axios.post(`https://backendsurgylife-1.onrender.com/footer`,{email,phone})
    .then((res)=>{

      alert("Added sucessfully")
      setEmail("")
      setPhone("")
    })
    .catch((err)=>{
      console.log(err)
    })
  }
  return (
    <>
   <footer >
     <section className={footerStyles.footer}>
         <div className='container'>
         <div className='row'>
          <div className='col-md-3'>
        <h4>About Health Care</h4>
        <p className='my-3'>
          SurgyLife is a multi-speciality healthcare platform delivering a hassle-free experience for all your surgeries and medical needs with personalized care.
        </p>
          </div>

         <div className='col-md-3'>
          <h4>Treatments</h4>
          <p className={`my-2 ${footerStyles.treatment}`}> <span> <ChevronRightIcon/></span>Cardiac Surgery</p>
            <p className={`my-2 ${footerStyles.treatment}`}><span> <ChevronRightIcon/></span> Facelift Surgery</p>
          <p className={`my-2 ${footerStyles.treatment}`}> <span> <ChevronRightIcon/></span> Orthopedic Surgery</p>
          <p className={`my-2 ${footerStyles.treatment}`}> <span> <ChevronRightIcon/></span>Hair PRP Treatment</p>
        
         </div>

          <div className='col-md-3'>
            <h4 className=''>Contact Us</h4>
            <div className='my-2'>
           
             <form onSubmit={footersubmitHandler}>

              <div className='mb-3 p-1 rounded-5'>
                <input type='email'
                 name='email' 
                 placeholder='Email'
                 value={email}
                                  className='form-control'

                 onChange={(e)=>setEmail(e.target.value)}
                 required //Mandatory

                 />
                 
              </div>

                 <div className='mb-3 p-1 rounded-5'>
                <input type='phone'
                 name='phone' 
                 placeholder='Number'
                 className='form-control'
                 value={phone}
                 onChange={(e)=>setPhone(e.target.value)}
                  required //Mandatory

                 />
              </div>

                 <div className='mob-3'>
                   <input type='submit'
                   className='btn btn-danger'
                   value='Submit'
                   />
                 </div>

             </form>
              </div>
          </div>
          <div className='col-md-3'>
            <h4>Address</h4>
            <p className='my-2'>Image Hospital Madhapur</p>
            <p className='my-2'> <span className={footerStyles.StarIcon}><LocalPhoneIcon/> </span>91+ 9160610000  </p>
            <p className='my-2'> <span className={footerStyles.StarIcon}><MailOutlineIcon/></span> info@imagehospitals.in</p>
            <p className='my-2'><span className={footerStyles.StarIcon}><FacebookIcon/></span> <span className={footerStyles.StarIcon}><InstagramIcon/></span> <span className={footerStyles.StarIcon}><TwitterIcon/></span></p>
            
        

          </div>

         </div>
        </div>

     </section>

    <section className={footerStyles.footerbottom}>
     <div className='container p-3'>
        <div className='row'>

            <div className='col-lg-6'>
                   <p>© 2025 ELearn Infotech.</p>
            </div>

            <div className='col-lg-6'>
                <p className='text-end'>Designed and Developed by the Aviligonda Yugendra Kumar</p>
            </div>

        </div>
    </div>
    
    </section>
   </footer>

   </>
  )
}

export default Footer
